<template>
  <div>
    <el-table :data="tableData" tooltip-effect="light" :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }">
      <el-table-column label="工单编号" align="center" width="150">
        <template slot-scope="scope">{{ scope.row.code || '-' }}</template>
      </el-table-column>
      <el-table-column label="报修人" align="center" width="120">
        <template slot-scope="scope">
          <div>{{ scope.row.submitUserName || '-' }}</div>
          <div>{{ scope.row.submitUserPhone || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="工单分类" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.worksheetType">{{ dictType('worksheetType', scope.row.worksheetType) }}{{ '>' }}</span>
          {{ scope.row.categoryName }}
        </template>
      </el-table-column>
      <el-table-column label="报修内容" align="center">
        <template slot-scope="scope">{{ scope.row.content || '-' }}</template>
      </el-table-column>
      <el-table-column label="工单来源" align="center">
        <template slot-scope="scope">
          {{ dictType('distributeSource', scope.row.source) }}
        </template>
      </el-table-column>
      <el-table-column label="紧急度" align="center">
        <template slot-scope="scope">
          <span
            :style="{
              color: getUrgentType(scope.row.urgentType),
              background: getUrgentTypeBg(scope.row.urgentType),
              padding: '2px 4px',
              borderRadius: '2px',
            }"
          >
            {{ dictType('urgentType', scope.row.urgentType) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="难易度" align="center">
        <template slot-scope="scope">
          {{ dictType('difficultyStatus', scope.row.difficulty) }}
        </template>
      </el-table-column>
      <el-table-column label="工单状态" align="center">
        <template slot-scope="scope">
          {{ dictType('distributeState', scope.row.state) }}
        </template>
      </el-table-column>
      <el-table-column label="反馈时间" align="center" width="160">
        <template slot-scope="scope">{{ cutTime(scope.row.createTime, ' ') }}</template>
      </el-table-column>
      <el-table-column prop="address" label="操作" fixed="right" width="200" align="center">
        <template slot-scope="scope">
          <div class="tableLeft">
            <el-link type="primary" @click="detail(scope.row)">详情</el-link>
            <el-link v-if="scope.row.state !== 5" v-permission="['worksheetUpd']" type="primary" @click="edit(scope.row)">修改</el-link>
            <el-link v-permission="['worksheetDisptch']" type="primary" @click="confirm(scope.row)">指派</el-link>
            <el-link v-if="scope.row.state === 5" v-permission="['visitListQuery']" type="primary" @click="returnVisit(scope.row)">回访</el-link>
            <el-link v-if="scope.row.isReturnVisit === 1 && scope.row.state === 5" v-permission="['visitListQuery']" type="primary" @click="returnVisitRecords(scope.row)">
              回访记录
            </el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pt-30"
      layout="total, prev, pager, next, jumper,sizes"
      background
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :page-sizes="[10, 50, 100]"
      :total="total"
      @size-change="currentChange"
      @current-change="currentChange"
    />
  </div>
</template>

<script>
import { worksheetCount, worksheetPage, worksheetDetail, worksheetHandleRecordList } from '@/api/workOrder'

export default {
  inject: ['indexThis'],
  data() {
    return {
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      tableData: [],
      total: 0,
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.worksheetPage()
    },
    async worksheetPage() {
      const params = {
        ...this.page,
        communityId: this.indexThis.communityId,
        buildingRoomId: this.indexThis.buildingRoomId,
      }
      const { data: res } = await worksheetPage(params)
      this.tableData = res || []
      const { data: total } = await worksheetCount(params)
      this.total = Number.parseInt(total)
    },
    // 获取详情
    async worksheetDetail(params) {
      const { data } = await worksheetDetail({ id: params.id })
      if (params.type === 'edit') {
        this.indexThis.$refs.CardWorkEdit.editForm = data
        this.indexThis.$refs.CardWorkEdit.init()
      }
      if (params.type === 'preview') {
        this.indexThis.$refs.CardWorkDetail.previewForm = data
        this.indexThis.$refs.CardWorkDetail.init()
      }
      if (params.type === 'confirm') this.indexThis.$refs.CardWorkListConfirmUser.previewForm = data
    },
    async worksheetHandleRecordList(params = {}) {
      const { data } = await worksheetHandleRecordList({ worksheetId: params.worksheetId, pageSize: 500 })
      if (params.type === 'preview') this.indexThis.$refs.CardWorkDetail.worksheetHandleRecordListArr = data
      if (params.type === 'confirm') this.indexThis.$refs.CardWorkListConfirmUser.worksheetHandleRecordListArr = data
    },
    detail(value) {
      this.worksheetHandleRecordList({
        worksheetId: value.id,
        type: 'preview',
      })
      this.worksheetDetail({ id: value.id, type: 'preview' })
      this.indexThis.$refs.CardWorkDetail.drawer = true
    },
    edit(value) {
      this.worksheetDetail({ id: value.id, type: 'edit' })
      this.indexThis.$refs.CardWorkEdit.drawer = true
    },
    confirm(value) {
      this.worksheetHandleRecordList({
        worksheetId: value.id,
        type: 'confirm',
      })
      this.worksheetDetail({ id: value.id, type: 'confirm' })
      this.indexThis.$refs.CardWorkListConfirmUser.addForm.worksheetId = value.id
      this.indexThis.$refs.CardWorkListConfirmUser.drawer = true
    },
    returnVisitRecords(value) {
      this.indexThis.$refs.CardWorkReturnVisitRecords.worksheetReturnViewList({
        worksheetId: value.id,
      })
      this.indexThis.$refs.CardWorkReturnVisitRecords.workOrderCode = value.code
      this.indexThis.$refs.CardWorkReturnVisitRecords.drawer = true
    },
    returnVisit(value) {
      this.indexThis.$refs.CardWorkOrderReturnVisit.worksheetId = value.id
      this.indexThis.$refs.CardWorkOrderReturnVisit.communityId = value.communityId
      this.indexThis.$refs.CardWorkOrderReturnVisit.drawer = true
    },
    sizeChange() {
      this.init()
    },
    currentChange() {
      this.worksheetPage()
    },
    getUrgentType(val1) {
      if (!val1) return
      if (val1 === 1) return '#EA0000'
      if (val1 === 2) return '#FF8F1F'
      if (val1 === 3) return '#00B578'
    },
    getUrgentTypeBg(val) {
      if (val === 1) return '#FFECE8'
      if (val === 2) return '#FFF7E8'
      if (val === 3) return '#E8FFEA'
    },
  },
}
</script>

<style lang="scss" scoped>
.tableLeft {
  padding-left: 12%;
}
</style>
